import {
  EducationalScreenV2,
  Query,
  Typenames,
  VlocPageDataV2,
} from '@varo/graphql-schema-types';
import GetEligibleNonEligibleDetails from 'services/graphql/queries/GetEligibleNonEligibleDetails';
import { AnyVariables, CombinedError, useQuery } from 'urql';

interface EligibilityDetails {
  result?: VlocPageDataV2;
  serializedData?: EducationalScreenV2;
  error?: CombinedError;
  isFetching: boolean;
  refetch: () => void;
}

const useGetEligibleNonEligibleDetails = (id: string): EligibilityDetails => {
  const [response, refetch] = useQuery<Query, AnyVariables>({
    query: GetEligibleNonEligibleDetails,
    variables: {
      input: {
        id,
      },
    },
    requestPolicy: 'network-only',
  });

  const { data, fetching, error } = response;

  const serializedData =
    data?.varoLineOfCreditPageV2.__typename === Typenames.EducationalScreenV2
      ? data.varoLineOfCreditPageV2
      : undefined;

  return {
    result: data?.varoLineOfCreditPageV2,
    serializedData,
    isFetching: fetching,
    error,
    refetch,
  };
};

export default useGetEligibleNonEligibleDetails;
